module.exports = __webpack_public_path__ + "static/banner-footer-update-data-bo-62f9b02be31027e09ae3c33af2c530cc.png";